import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Globals } from '../../ressources/variables/globals';

/**
 * Service pour la gestion de l'historique des imports
 * Note: L'authentification est gérée automatiquement via les cookies de session Laravel
 * grâce à l'intercepteur CredentialsInterceptor
 */
@Injectable()
export class HistoricService {

  serverEndpoint = Globals.serverEndpoint;

  constructor(private http: HttpClient) { }

  getHistoric(self: boolean): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    if (self) {
      return this.http.get(this.serverEndpoint + '/api/getHistoric', { headers }).toPromise();
    } else {
      return this.http.get(this.serverEndpoint + '/api/getAllHistoric', { headers }).toPromise();
    }
  }

  deleteSelfHistoric(id_session: number): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('session', id_session.toString());

    return this.http.post(this.serverEndpoint + '/api/deleteSelfHistoric', body.toString(), { headers }).toPromise();
  }
}
